import React, { useId } from 'react';
import { cn } from '../../utils/cn';
import type { RadioButtonProps } from './radio-button.types';

const RadioButton: React.FC<RadioButtonProps> = ({
    value,
    checked,
    disabled = false,
    label,
    name,
    onValueChange,
    onChange,
    className,
    id: providedId,
    ...props
}) => {
    const generatedId = useId();
    const id = providedId || generatedId;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange?.(e);
        if (e.target.checked) {
            onValueChange?.(value);
        }
    };

    return (
        <div className={cn('flex items-center gap-2', className)}>
            <input
                type="radio"
                id={id}
                name={name}
                value={value}
                checked={checked}
                disabled={disabled}
                onChange={handleChange}
                className={cn(
                    'h-5 w-5 border-2 border-[var(--color-neutral-40)] text-[var(--color-primary-100)]',
                    'focus:ring-2 focus:ring-[var(--color-primary-100)] focus:ring-offset-2',
                    'disabled:cursor-not-allowed disabled:opacity-50',
                    'cursor-pointer transition-colors'
                )}
                {...props}
            />
            {label && (
                <label
                    htmlFor={id}
                    className={cn(
                        'text-sm cursor-pointer select-none',
                        disabled
                            ? 'text-[var(--color-neutral-50)] cursor-not-allowed'
                            : 'text-[var(--color-neutral-90)]'
                    )}
                >
                    {label}
                </label>
            )}
        </div>
    );
};

export default RadioButton;
